<div class="portal-wrapper">
  <!-- ── Sidebar ── -->
  <aside class="sidebar">
    <div class="sb-brand">
      <div class="sb-brand-name">JusticeFlow NG</div>
      <span class="sb-brand-org">{{ portalTitle }}</span>
    </div>

    <nav class="sb-nav">
      <ng-container *ngFor="let item of navItems">
        <div class="sb-label" *ngIf="item.sectionLabel">
          {{ item.sectionLabel }}
        </div>

        <!-- Routed nav item -->
        <a
          *ngIf="item.route && !item.isSignOut"
          class="ni"
          [routerLink]="item.route"
          [class.active]="isActive(item)"
        >
          <span class="ni-icon" [innerHTML]="safeIcon(item.icon)"></span>
          {{ item.label }}
          <span class="ni-count" *ngIf="badgeFor(item)">{{ badgeFor(item) }}</span>
        </a>

        <!-- Sign out button -->
        <button *ngIf="item.isSignOut" class="ni" (click)="signOut()">
          <span class="ni-icon" [innerHTML]="safeIcon(item.icon)"></span>
          {{ item.label }}
        </button>

        <!-- Non-routed action (no route, no signout) -->
        <button *ngIf="!item.route && !item.isSignOut" class="ni">
          <span class="ni-icon" [innerHTML]="safeIcon(item.icon)"></span>
          {{ item.label }}
          <span class="ni-count" *ngIf="badgeFor(item)">{{ badgeFor(item) }}</span>
        </button>
      </ng-container>
    </nav>

    <div class="sb-foot">
      <div class="sb-user">
        <div class="sb-avatar">{{ user.initials }}</div>
        <div>
          <div class="sb-uname" style="text-transform: capitalize">
            {{ user.name }}
          </div>
          <div class="sb-urole">
            {{ user.role
            }}<ng-container *ngIf="user.id"> · {{ user.id }}</ng-container>
          </div>
        </div>
      </div>
    </div>
  </aside>

  <!-- ── Main ── -->
  <div class="portal-main">
    <header class="topbar">
      <div class="tb-left">
        <span>{{ portalTitle }}</span>
        <span class="sep">›</span>
        <span class="cur">{{ breadcrumb }}</span>
      </div>
      <div class="tb-right">
        <button class="tb-btn" title="Notifications">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
          <span class="tb-dot" *ngIf="hasNotifications"></span>
        </button>
        <div class="tb-user">
          <div class="tb-user-av">{{ user.initials }}</div>
          <span style="text-transform: capitalize">{{ user.name }}</span>
        </div>
      </div>
    </header>

    <router-outlet></router-outlet>
  </div>
</div>

<!-- Chat drawer — fixed-position, rendered for all portals but only visible when a judge opens it -->
<app-case-chat-drawer></app-case-chat-drawer>
